import { Carousel, CarouselApi, CarouselContent, CarouselItem } from '@/components/common/Carousel';
import { Tabs, TabsContent, TabsList, TabsTriggerAcc } from '@/components/common/Tabs';
import { APPROVE_BIKE_STATUS_CONFIG } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TabItem from './tab';
import { APPROVE_BIKE_STATUS } from '@/types/enums';

const TAB_MIN_WIDTH = 200;

export default observer(function ApproveBikes() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        uiStore: {
            windowSize: { width }
        }
    } = useStore();

    // state
    const [activeTab, setActiveTab] = useState<string>(APPROVE_BIKE_STATUS.WaittingApprove.toString());
    const [api, setApi] = useState<CarouselApi>();

    // functions
    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
        api?.scrollTo(
            Object.values(APPROVE_BIKE_STATUS_CONFIG).filter(item => item.value !== APPROVE_BIKE_STATUS.ResendApprove).findIndex(item => item.value === Number(tabValue)),
            false
        );
    };

    return (
        <div>
            <Tabs
                value={activeTab}
                onValueChange={handleTabChange}
                className='w-full'
            >
                {width > TAB_MIN_WIDTH * Object.values(APPROVE_BIKE_STATUS_CONFIG).filter(item => item.value !== APPROVE_BIKE_STATUS.ResendApprove).length ?
                    (
                        <TabsList
                            className='grid w-full gap-1.5 grid-cols-3'
                        >
                            { Object.values(APPROVE_BIKE_STATUS_CONFIG).filter(item => item.value !== APPROVE_BIKE_STATUS.ResendApprove).map(({ value, key }, index) => (
                                <TabsTriggerAcc
                                    key={index}
                                    value={value.toString()}
                                >
                                    {t(`field.${key}`)}
                                </TabsTriggerAcc>
                            ))}
                        </TabsList>
                    ) :
                    (
                        <TabsList className='w-full'>
                            <Carousel
                                opts={{
                                    align: 'start'
                                }}
                                className='w-full'
                                setApi={setApi}
                            >
                                <CarouselContent className='w-full snap-x snap-mandatory ml-0 gap-1.5'>
                                    { Object.values(APPROVE_BIKE_STATUS_CONFIG).filter(item => item.value !== APPROVE_BIKE_STATUS.ResendApprove).map(({ value, key }, index) => (
                                        // <CarouselItem key={index} className='basis-[60%] point-375:basis-[40%] xsm:basis-[35%] point-600:basis-[28%] pl-0'>
                                        <CarouselItem key={index} className='basis-[180px] pl-0'>
                                            <TabsTriggerAcc
                                                key={index}
                                                value={value.toString()}
                                                className='w-full basis-auto'
                                            >
                                                {t(`field.${key}`)}
                                            </TabsTriggerAcc>
                                        </CarouselItem>
                                    ))}
                                </CarouselContent>
                            </Carousel>
                        </TabsList>
                    )}

                { Object.values(APPROVE_BIKE_STATUS_CONFIG).filter(item => item.value !== APPROVE_BIKE_STATUS.ResendApprove).map(({ value }, index) => (
                    <TabsContent key={index} value={value.toString()} className='mt-0'>
                        <TabItem approveStatus={value} />
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    );
});
